import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/oPEq6DebMDYfUHT8reNZbP/Mockup_1x1_-_OFN1_(Estres_y_Relajacion).webp';
export function Hero() {
  // Headline and mockup render immediately (no entrance animation) so the
  // largest contentful paint is never delayed by JavaScript.
  return <section className="relative overflow-hidden bg-surface px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-65" data-mp="128z0cez35zzp">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-primary/40" data-id="element-66" data-mp="xaxejma9zmkj" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-67" data-mp="s9zxxe4wz0l5">
        <p className="-mb-2.5 -mt-11 font-display text-lg font-bold tracking-brand text-primary-soft sm:text-2xl" data-id="element-68" data-mp="ncq13df73mna">
          🌿BIOMA LÍVIDO™
        </p>
        <h1 className="mx-auto mt-5 max-w-5xl font-display text-lg font-bold text-foreground sm:text-5xl lg:text-6xl" style={{
        fontSize: "21px"
      }} data-id="element-69" data-mp="3d2tqbf4z2uh6">
          Tené siempre una rutina de autocuidado lista para usar,{' '}
          <span className="text-primary-soft" data-id="element-70" data-mp="3o7lv7zxu9mt6">
            según lo que necesitás y tu tiempo.
          </span>
        </h1>
        <div className="mx-auto -my-3 max-w-xs sm:-my-7 sm:max-w-lg" data-id="element-71" data-mp="39b4gcyqfxq1v">
          <img src={mockupUrl} alt="Mockup del Sistema Equilibrio en Casa: 4 volúmenes" width="1254" height="1254" fetchPriority="high" loading="eager" decoding="async" className="aspect-square w-full drop-shadow-2xl" data-id="element-72" data-mp="3e9fqzbok84l5" />
        </div>
        <div className="mx-auto max-w-2xl" data-id="element-73" data-mp="359t19n570n7x">
          <p className="-mb-2 font-display text-base font-bold tracking-label text-highlight sm:text-xl" data-id="element-74" data-mp="35audvw1uxhrr">
            SISTEMA EQUILIBRIO EN CASA™
          </p>
          <p className="-mb-2.5 mt-3 text-sm leading-relaxed text-foreground-soft sm:text-base" data-id="element-75" data-mp="2vjzowjx8842m">
            El sistema práctico que organiza prácticas, protocolos y rutinas listas para que sepas qué hacer sin empezar desde cero.
          </p>
          <div className="-mb-3 mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-foreground-muted sm:text-sm" data-id="element-76" data-mp="2lmlaepuv5pcy">
            <span className="inline-flex items-center gap-2 rounded-full border border-foreground/15 bg-canvas px-3 py-2" data-id="element-77" data-mp="nat8heoiaqma">
              <FileTextIcon className="h-4 w-4 text-primary-soft" data-id="element-78" data-mp="id9tgcjzi9ta" />
              100% PDF
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-foreground/15 bg-canvas px-3 py-2" data-id="element-79" data-mp="degcub9ei2ow">
              <ZapIcon className="h-4 w-4 text-highlight" data-id="element-80" data-mp="1ayt8l57pjtdj" />
              Acceso inmediato
            </span>
          </div>
        </div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-7 max-w-lg" data-id="element-81" data-mp="1126polyxzce5">
          <ActionButton href="#pricing" showTrust data-id="element-82" data-mp="3lu9w2xv49s9n">
            🌿 QUIERO MI SISTEMA DE AUTOCUIDADO
          </ActionButton>
        </motion.div>
      </div>
    </section>;
}